import { render, staticRenderFns } from "./RichTextModal.vue?vue&type=template&id=a2a3dec8"
import script from "./RichTextModal.vue?vue&type=script&lang=js"
export * from "./RichTextModal.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2a3dec8')) {
      api.createRecord('a2a3dec8', component.options)
    } else {
      api.reload('a2a3dec8', component.options)
    }
    module.hot.accept("./RichTextModal.vue?vue&type=template&id=a2a3dec8", function () {
      api.rerender('a2a3dec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/dataReport/modules/RichTextModal.vue"
export default component.exports